// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3VTCy","productName":"Table_productName__2ADTb"};